import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Upload, UserPlus, Send, History, Trash2, Pencil, Mail, Users, Loader2 } from "lucide-react";

const EmptyGroup = ({ onCreate }) => (
  <Card>
    <CardContent className="py-16 text-center">
      <Users className="w-14 h-14 mx-auto text-muted-foreground/30" />
      <p className="text-muted-foreground mt-4">Wählen oder erstellen Sie eine Gruppe</p>
      <Button className="mt-4" onClick={onCreate}>
        <Plus className="w-4 h-4 mr-2" /> Neue Gruppe
      </Button>
    </CardContent>
  </Card>
);

export const GroupDetail = ({
  group,
  importing,
  onImportClick,
  onRename,
  onAddContact,
  onSend,
  onHistory,
  onDeleteGroup,
  onEditContact,
  onDeleteContact,
  onCreateGroup,
}) => {
  if (!group) return <EmptyGroup onCreate={onCreateGroup} />;
  const contacts = group.contacts || [];
  return (
    <Card>
      <CardHeader className="border-b">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="min-w-0">
            <CardTitle className="flex items-center gap-2 break-words" data-testid="selected-group-name">
              {group.name}
              <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onRename} data-testid="rename-group-btn">
                <Pencil className="w-3.5 h-3.5" />
              </Button>
            </CardTitle>
            <p className="text-sm text-muted-foreground mt-1">{contacts.length} Empfänger</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button variant="outline" size="sm" onClick={onImportClick} disabled={importing} data-testid="import-csv-btn">
              {importing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
              Outlook (.msg) importieren
            </Button>
            <Button variant="outline" size="sm" onClick={onAddContact} data-testid="add-contact-btn">
              <UserPlus className="w-4 h-4 mr-2" />
              Kontakt
            </Button>
            <Button size="sm" onClick={onSend} disabled={contacts.length === 0} data-testid="send-mailing-btn">
              <Send className="w-4 h-4 mr-2" />
              Rundmail
            </Button>
            <Button variant="outline" size="sm" onClick={onHistory} data-testid="history-btn">
              <History className="w-4 h-4 mr-2" />
              Verlauf
            </Button>
            <Button variant="ghost" size="icon" className="text-destructive" onClick={onDeleteGroup} data-testid="delete-group-btn">
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {contacts.length > 0 ? (
          <div className="divide-y">
            {contacts.map((c) => (
              <div key={c.id} className="flex items-center justify-between gap-3 px-4 py-3 hover:bg-muted/40" data-testid={`contact-row-${c.id}`}>
                <div className="min-w-0">
                  <p className="font-medium truncate">{c.name || "—"}</p>
                  <p className="text-sm text-muted-foreground truncate">{c.email}</p>
                </div>
                <div className="flex gap-1 shrink-0">
                  <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onEditContact(c)} data-testid={`edit-contact-${c.id}`}>
                    <Pencil className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-destructive" onClick={() => onDeleteContact(c)} data-testid={`delete-contact-${c.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-14 text-center">
            <Mail className="w-12 h-12 mx-auto text-muted-foreground/30" />
            <p className="text-muted-foreground mt-3">Keine Kontakte in dieser Gruppe</p>
            <p className="text-xs text-muted-foreground mt-1">Outlook-Datei (.msg) importieren – Empfänger (An/CC) oder Mitglieder einer Verteilerliste werden übernommen</p>
            <div className="flex justify-center gap-2 mt-4">
              <Button variant="outline" size="sm" onClick={onImportClick} disabled={importing} data-testid="import-csv-empty-btn">
                <Upload className="w-4 h-4 mr-2" /> Outlook (.msg) importieren
              </Button>
              <Button size="sm" onClick={onAddContact}>
                <UserPlus className="w-4 h-4 mr-2" /> Kontakt hinzufügen
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
